function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 5,
  width: 56,
  height: 56,
  rx: 1,
  fill: "#EF6969"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.7032 23.0866C46.2236 22.5662 46.2236 21.7224 45.7032 21.202C45.1828 20.6815 44.339 20.6815 43.8185 21.202L32.9993 32.0212L22.1808 21.2027C21.6603 20.6823 20.8165 20.6823 20.2961 21.2027C19.7757 21.7231 19.7757 22.5669 20.2961 23.0873L31.1146 33.9059L21.2026 43.8179C20.6822 44.3384 20.6822 45.1821 21.2026 45.7026C21.723 46.223 22.5668 46.223 23.0873 45.7026L32.9993 35.7906L42.912 45.7033C43.4325 46.2237 44.2763 46.2237 44.7967 45.7033C45.3171 45.1829 45.3171 44.3391 44.7967 43.8186L34.884 33.9059L45.7032 23.0866Z",
  fill: "white"
});

var SvgAdminDecline = function SvgAdminDecline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdminDecline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AdminDecline.f84badbc.svg";
export { ForwardRef as ReactComponent };